// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 565) return "static/chunks/565-ea94a72a39cfa60a.js";
	if (chunkId === 911) return "static/chunks/911-56d9e5d660bfaf16.js";
	// return url for filenames based on template
	return "static/chunks/" + ({"479":"795d4814","512":"9c4e2130","711":"8e1d74a4"}[chunkId] || chunkId) + "." + {"4":"1f0c9bce98a15dc4","72":"e6a7289dc1bbb09b","269":"fc1e75b823a65d6b","479":"35b4540ca6b02933","512":"694f627c39e25c08","664":"cce9edcfeb9b9c11","711":"a71cfe6a3ae901e7","960":"74ec9fa8b115f793","999":"1dbadc9438891fdf"}[chunkId] + ".js";
};